




















import Vue from 'vue'

export default Vue.extend({
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    value:{
      type: [Boolean,Array,String,Object],
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    selectedValue: {
      type: [Boolean,Array,String,Object],
      default: false
    },
    disabled: {
      type: [Boolean,Array,String],
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    }
  }
})
